import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useMemo } from "react";
import { useAuth } from "@qure/qure-auth";
import { useWorkspaceCustomFields } from "@/hooks/custom-fields";
import { usePatientTagsStore } from "@/stores/patient-tags";
import { mapCustomTagsToAITags } from "@/utils/tags";
import { useApplyReportTag } from "./use-apply-report-tag";
/** Resolves per-version AI tags for a report and exposes an apply-tag handler, so a ReportItem can be rendered outside the link modal (timeline, citations). */
export function useReportVersionTags(versions) {
  var _userInfo$default_wor;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var workspaceId = (_userInfo$default_wor = userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace) !== null && _userInfo$default_wor !== void 0 ? _userInfo$default_wor : null;
  var _useWorkspaceCustomFi = useWorkspaceCustomFields(workspaceId, Boolean(workspaceId)),
    _useWorkspaceCustomFi2 = _useWorkspaceCustomFi.data,
    customFields = _useWorkspaceCustomFi2 === void 0 ? [] : _useWorkspaceCustomFi2;
  var patientTags = usePatientTagsStore(function (s) {
    return s.serverTags;
  });
  var _useApplyReportTag = useApplyReportTag(),
    applyTag = _useApplyReportTag.applyTag,
    applyingTagId = _useApplyReportTag.applyingTagId;
  var versionsWithTags = useMemo(function () {
    return versions.map(function (v) {
      return _objectSpread(_objectSpread({}, v), {}, {
        aiTags: mapCustomTagsToAITags(v.custom_tags, customFields, patientTags)
      });
    });
  }, [versions, customFields, patientTags]);
  var onApplyTag = useCallback(function (tag) {
    var _tag$tagId;
    return applyTag({
      tag_id: (_tag$tagId = tag.tagId) !== null && _tag$tagId !== void 0 ? _tag$tagId : Number(tag.id),
      response: tag.response
    });
  }, [applyTag]);
  return {
    versions: versionsWithTags,
    onApplyTag: onApplyTag,
    applyingTagId: applyingTagId != null ? String(applyingTagId) : null
  };
}